module.exports = __webpack_public_path__ + "static/media/1417943590.b3e0e730.ttf";